import { Link } from '@tanstack/react-router'
import { LayoutDashboard, Bot, BarChart3, Settings, Zap, LogOut, Receipt } from 'lucide-react'
import { cn } from '@/lib/cn'
import { signOut } from '@/lib/auth-client'
import { useT } from '@/i18n/provider'
import config from '@config'

const NAV_ITEMS = [
  { to: '/dashboard',         labelKey: 'sidebar.dashboard',  icon: LayoutDashboard },
  { to: '/dashboard/agents',  labelKey: 'sidebar.agents',     icon: Bot },
  { to: '/dashboard/usage',   labelKey: 'sidebar.usage',      icon: BarChart3 },
  { to: '/dashboard/billing', labelKey: 'sidebar.billing',    icon: Receipt },
  { to: '/settings',          labelKey: 'sidebar.settings',   icon: Settings },
] as const

export function Sidebar() {
  const t = useT()

  return (
    <aside
      className={cn(
        'glass flex flex-col w-60 min-h-screen',
        'border-r border-white/10 rounded-none',
        'transition-all duration-300',
      )}
    >
      {/* Logo */}
      <div className="flex items-center gap-3 px-5 py-5 border-b border-white/10">
        <Zap className="text-[var(--oc-accent-light)] flex-shrink-0" size={20} />
        <span className="font-bold text-white text-base leading-none">
          {config.app.name}
        </span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV_ITEMS.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={cn(
              'flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm',
              'text-white/55 hover:text-white hover:bg-white/8',
              'transition-all duration-150',
            )}
            activeProps={{
              className: cn(
                'flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm',
                'text-white bg-[var(--oc-accent)]/20 border border-[var(--oc-accent)]/30',
              ),
            }}
            activeOptions={{ exact: item.to === '/dashboard' }}
          >
            <item.icon size={17} />
            {t(item.labelKey)}
          </Link>
        ))}
      </nav>

      {/* Sign out */}
      <div className="px-3 py-4 border-t border-white/10">
        <button
          onClick={() => signOut().then(() => window.location.href = '/auth/login')}
          className={cn(
            'flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-sm',
            'text-white/40 hover:text-red-400 hover:bg-red-500/10',
            'transition-all duration-150',
          )}
        >
          <LogOut size={17} />
          {t('sidebar.signOut')}
        </button>
      </div>
    </aside>
  )
}
